import React, { Component } from 'react';

class GrFooter extends Component {
    render() {
        let tncUrl = "", ppUrl = "", contactUrl = "", faqUrl = "", withdrawUrl = "";
        let url = window.location.host;
        const lang = sessionStorage.getItem('lang');
        const msisdn = sessionStorage.getItem("msisdn");
        const rockmanId = sessionStorage.getItem('rockmanId');

        if (url.indexOf('gr-mobimilia') >= 0) {
            tncUrl = "https://n.mobioastro.com/gr/tnc-lilymobile-ast?offer=1&_next=general_conditions.html&_extracted=f9d438b3a3cc472d96afc17f20b78d34&_next=general_conditions.html&_extracted=f9d438b3a3cc472d96afc17f20b78d34&";
            ppUrl = "https://n.mobioastro.com/gr/tnc-lilymobile-ast?offer=1&_next=privacy_policy.html&_extracted=f9d438b3a3cc472d96afc17f20b78d34&_next=privacy_policy.html&_extracted=f9d438b3a3cc472d96afc17f20b78d34&";
            contactUrl = "https://n.mobioastro.com/gr/tnc-lilymobile-ast?offer=1&_next=contact.html&_extracted=f9d438b3a3cc472d96afc17f20b78d34&_next=contact.html&_extracted=f9d438b3a3cc472d96afc17f20b78d34&";
            faqUrl = "https://n.mobioastro.com/gr/tnc-lilymobile-ast?offer=1&_next=faq.html&_extracted=f9d438b3a3cc472d96afc17f20b78d34&_next=faq.html&_extracted=f9d438b3a3cc472d96afc17f20b78d34&";
            withdrawUrl = `https://checksubscription.com/withdraw?c=gr-mobimilia&product=gr-mobimilia.mobioastro.com&country=gr&language=${lang}&portalSource=gr-mobimilia.mobioastro.com&rockmanId=${rockmanId}&msisdn=${msisdn}`;
        }
        else {
            tncUrl = "http://n.mobioastro.com/gr/tnc-mobioastro?offer=1&_next=general_conditions.html";
            ppUrl = "http://n.mobioastro.com/gr/tnc-mobioastro?offer=1&_next=privacy_policy.html";
            contactUrl = "http://n.mobioastro.com/gr/tnc-mobioastro?offer=1&_next=contact.html";
        }

        return (
            <div>
                <a href={tncUrl} target="_blank" rel="noopener noreferrer">Όροι και Προϋποθέσεις</a> &nbsp; | &nbsp;
                <a href={ppUrl} target="_blank" rel="noopener noreferrer">Πολιτική Απορρήτου</a> &nbsp; | &nbsp;
                <a href={contactUrl} target="_blank" rel="noopener noreferrer">Επικοινωνία</a>
                {faqUrl.indexOf('http') >= 0 ? <span>&nbsp; | &nbsp;</span> : ''}
                {faqUrl.indexOf('http') >= 0 ? <a href={faqUrl} target="_blank" rel="noopener noreferrer">Συχνές Ερωτήσεις</a> : ""}
                {withdrawUrl.indexOf('http') >= 0 ? <span>&nbsp; | &nbsp;</span> : ''}
                {withdrawUrl.indexOf('http') >= 0 ? <a href={withdrawUrl} target="_blank" rel="noopener noreferrer">Αποχώρηση από τη Σύμβαση</a> : ""}
            </div>
        );
    }
}

export default GrFooter;


// WEBPACK FOOTER //
// ./src/mobioastro/components/footer/grfooter.js